import axios from "../axios";

/**
 * Get app controls (public endpoint)
 * GET /api/getAppControls
 */
export const getAppControls = async () => {
  try {
    const response = await axios.get("/getAppControls");
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || "Failed to fetch app controls";
  }
};
